import { render, staticRenderFns } from "./NivelOrdinario.vue?vue&type=template&id=7be1f3d2&scoped=true"
import script from "./NivelOrdinario.vue?vue&type=script&lang=js"
export * from "./NivelOrdinario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be1f3d2",
  null
  
)

export default component.exports